import {
  GET_DEPARTMENT_STATISTICS_FAIL,
  GET_DEPARTMENT_STATISTICS_START,
  GET_DEPARTMENT_STATISTICS_SUCCESS,
  GET_DEPARTMENTS_FAIL,
  GET_DEPARTMENTS_START,
  GET_DEPARTMENTS_SUCCESS,
} from './constants';

const initialState = {
  departments: null,
  departmentsTotal: null,
  departmentsPageSize: null,
  departmentsPageNumber: null,
  departmentStatistics: null,
  departmentStatisticsTotal: null,
  departmentStatisticsPageSize: null,
  departmentStatisticsPageNumber: null,
  isLoading: false,
};

// eslint-disable-next-line
export default (state = initialState, { type, response, headers }) => {
  switch (type) {
    case GET_DEPARTMENTS_START:
      return {
        ...state,
        departments: null,
        departmentsTotal: null,
        departmentsPageSize: null,
        departmentsPageNumber: null,
        isLoading: true,
      };

    case GET_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departments: response?.content || [],
        departmentsTotal: Number(headers.get('X-Total-Elements')) || 0,
        departmentsPageSize: Number(headers.get('X-Page-Size')) || 0,
        departmentsPageNumber: Number(headers.get('X-Page-Number')) || 0,
        isLoading: false,
      };

    case GET_DEPARTMENTS_FAIL:
      return { ...state, isLoading: false };

    case GET_DEPARTMENT_STATISTICS_START:
      return {
        ...state,
        isLoading: true,
        departmentStatistics: null,
      };

    case GET_DEPARTMENT_STATISTICS_SUCCESS:
      return {
        ...state,
        departmentStatistics: response,
        departmentStatisticsTotal: Number(headers.get('X-Total-Elements')) || 0,
        departmentStatisticsPageSize: Number(headers.get('X-Page-Size')) || 0,
        departmentStatisticsPageNumber: Number(headers.get('X-Page-Number')) || 0,
        isLoading: false,
      };

    case GET_DEPARTMENT_STATISTICS_FAIL:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
